import EventEmitter from 'eventemitter3'

export const events = new EventEmitter()

export const WALLETS_APPLY = 'wallets.apply'
export const WALLETS_OPERATED = 'wallets.operated'
export const GAME_INFO = 'game.info'
export const GAME_STARTED = 'game.started'
export const GAME_PLAY = 'game.play'
export const BET = 'bet'
export const BET_DONE = 'bet.done'
export const BET_CANCEL = 'bet.cancel'
export const PLAYERS_JOIN = 'players.join'

const KICKOUT = 'kickout'

export default {
  listen (user) {
    const es = new EventSource(`/listen/channels/agents,agent:${user.agent},agent:${user.agent}:${user.username},game:${user.game}`, { withCredentials: true })
    if (user.role === 'admin') {
      es.addEventListener(WALLETS_APPLY, (e) =>  events.emit(WALLETS_APPLY, JSON.parse(e.data)))
      es.addEventListener(WALLETS_OPERATED, (e) =>  events.emit(WALLETS_OPERATED, JSON.parse(e.data)))
      es.addEventListener(GAME_INFO, (e) =>  events.emit(GAME_INFO, JSON.parse(e.data)))
      es.addEventListener(GAME_STARTED, (e) =>  events.emit(GAME_STARTED, JSON.parse(e.data)))
      es.addEventListener(GAME_PLAY, (e) => events.emit(GAME_PLAY, JSON.parse(e.data)))
      es.addEventListener(BET, (e) =>  events.emit(BET, JSON.parse(e.data)))
      es.addEventListener(BET_DONE, (e) =>  events.emit(BET_DONE, JSON.parse(e.data)))
      es.addEventListener(BET_CANCEL, (e) =>  events.emit(BET_CANCEL, JSON.parse(e.data)))
      es.addEventListener(PLAYERS_JOIN, (e) =>  events.emit(PLAYERS_JOIN, JSON.parse(e.data)))
    }
    es.addEventListener(KICKOUT, (e) => { document.location.reload() })
  }
}
